import React from 'react';
import { FiInbox } from 'react-icons/fi';

const EmptyState = ({ title, description, actionText, onAction, icon: Icon = FiInbox }) => {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '3.5rem 1.5rem',
        background: '#1E293B',
        borderRadius: '16px',
        border: '1px dashed rgba(255, 255, 255, 0.12)'
      }}
    >
      <div
        style={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          background: 'rgba(99, 102, 241, 0.12)',
          color: 'var(--primary-500)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.25rem auto',
          fontSize: '1.8rem'
        }}
      >
        <Icon />
      </div>
      <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.25rem', marginBottom: '0.5rem', color: '#fff' }}>
        {title}
      </h3>
      {description && (
        <p style={{ color: '#94A3B8', fontSize: '0.95rem', maxWidth: '420px', margin: '0 auto 1.5rem auto' }}>
          {description}
        </p>
      )}
      {actionText && onAction && (
        <button onClick={onAction} className="btn btn-primary btn-sm">
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
